import { Icon, TIconProps } from '@/common/components/Icons/Icon';
import { MenhirBudgetLogos } from '@/common/integrations/menhir/employee/budgets/budgets.types';

export function BudgetIcon({
  type,
  height,
  width,
  size,
  color,
}: Omit<TIconProps, 'icon'> & { type: MenhirBudgetLogos }) {
  const props = {
    color,
    width,
    height,
    size,
  };
  switch (type) {
    case 'default':
    default:
      return <Icon icon="face-grin-stars" {...props} />;
    case 'award':
      return <Icon icon="award" {...props} />;
    case 'books':
      return <Icon icon="book" {...props} />;
    case 'knowledge':
      return <Icon icon="brain" {...props} />;
    case 'food':
      return <Icon icon="burger" {...props} />;
    case 'car':
      return <Icon icon="car-side" {...props} />;
    case 'leisure':
      return <Icon icon="chair" {...props} />;
    case 'technology':
      return <Icon icon="desktop" {...props} />;
    case 'entertainment':
      return <Icon icon="headphones" {...props} />;
    case 'misc':
      return <Icon icon="icons" {...props} />;
    case 'transportation':
      return <Icon icon="taxi" {...props} />;
    case 'electricity':
      return <Icon icon="bolt-lightning" {...props} />;
    case 'travel':
      return <Icon icon="suitcase-rolling" {...props} />;
    case 'fitness':
      return <Icon icon="heart-pulse" {...props} />;
    case 'wellness':
      return <Icon icon="shield-heart" {...props} />;
    case 'disability':
      return <Icon icon="wheelchair-move" {...props} />;
    case 'quit_smoking':
      return <Icon icon="ban-smoking" {...props} />;
    case 'lose_weight':
      return <Icon icon="weight-scale" {...props} />;
    case 'vaccination':
      return <Icon icon="syringe" {...props} />;
    case 'baby':
      return <Icon icon="baby-carriage" {...props} />;
  }
}
